import { isNil } from 'lodash';
import { pipe } from 'lodash/fp';
import { displayText } from './displayText';

const format = (params?: number | { value?: number }, options?: Intl.NumberFormatOptions): string => {
  const formatter = new Intl.NumberFormat(window.navigator.language, options);
  if (typeof params === 'object') {
    return isNil(params.value) ? '' : formatter.format(params.value);
  }
  return isNil(params) ? '' : formatter.format(params);
};

const thousandsSeparator: string =
  new Intl.NumberFormat().formatToParts(1111111).find((_) => _.type === 'group')?.value || ' ';

export const formatters = {
  number: {
    format,
    thousandsSeparator,
    radix: thousandsSeparator === ',' ? '.' : ',',
    formatWithDisplayText: pipe(format, displayText),
  },
};
